import { useLazyQuery } from '@apollo/client'

import { GetProductModalProductTagsDocument } from '@/graphql/purchase-plus/generated/getProductModalProductTags.generated'
import { TagTypeEnum } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalProductTagsProps {
  productId: number
}

export const useGetProductModalProductTags = ({ productId }: UseGetProductModalProductTagsProps) => {
  const [fetchProductModalProductTags, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductModalProductTagsDocument,
    {
      variables: {
        productId,
        tagFilters: {
          tagTypeEq: TagTypeEnum.Product,
        },
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
    }
  )

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductModalProductTags,
    error,
    tags: data?.product?.productTags?.unpaginated || [],
    loadingStates,
    refetch,
  }
}
